import { AutorizationForm } from "@src/features/auth";
import { Box, Typography } from "@mui/material";
import wave from "@src/shared/assets/header copy 2.png";
import logo from "@src/shared/assets/logo_1.png";

import styles from "./styles.module.scss";

export const AutorizationPage = () => {
  return (
    <>
      <Box className={styles.root}>
        <img src={wave} alt='wave' className={styles.wave} />
        <div className={styles.leftPanel}>
          <AutorizationForm />
        </div>
        <Box className={styles.rightPanel}>
          <img src={logo} alt='logo' className={styles.logo} />
          <Typography className={styles.slogan}>
            Помощник по найму
            <br />
            сотрудников 24/7
          </Typography>
        </Box>
      </Box>
    </>
  );
};
